<template>
  <div
    :class="`
      label-outlined-component-container
      ${!is_disabled
        ? 'label-outlined-component-container-active'
        : ''
      }
      ${dark
        ? is_ready
          ? 'label-outlined-component-container-dark-ready'
          : 'label-outlined-component-container-dark'
        : is_ready
          ? 'label-outlined-component-container-light-ready'
          : 'label-outlined-component-container-light'
      }`
    "
    :style="`
      ${width
        ? `min-width: ${width}; max-width: ${width};`
        : 'width: 100%;'
      }
      min-height: ${height || 0}px;
      margin-top: ${label ? '5px' : ''};
      ${is_disabled?'cursor: default':''}
    `"
  >
    <!-- CENTER TOP -->
    <div
      v-if="label"
      :class="`label-outlined-component-top-label ${background_color.substring(0,1) !== '#' ? background_color : ''}`"
      :style="`${background_color.substring(0,1) === '#' ? `background-color: ${background_color}` : ''};`"
    >
      <TText
        :value="`${label}`"
        :color="dark ? '#000' : '#FFF'"
        :size="8"
        font_weight="300"
      />
      <!-- TODO: insert whitespace -->
      <TText
        v-if="label_suffix"
        :text="`${label_suffix}`"
        :color="dark ? '#000' : '#FFF'"
        :size="8"
        font_weight="300"
      />
    </div>
      <!-- {{ label }} {{label_suffix}}
    </span> -->
    <!-- <span
      v-if="label"
      :class="`label-outlined-component-top-label ${background_color.substring(0,1) !== '#' ? background_color : ''}`"
      :style="`color:${dark ? '#000' : '#FFF'}; ${background_color.substring(0,1) === '#' ? `background-color: ${background_color}` : ''};`"
    >
      {{ label }} {{label_suffix}}
    </span> -->

    <!-- CENTER SLOT -->
    <div class="label-outlined-component-content">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
import TText from '@/components/Taktify/TText.component.vue';

  export default {
    props: [
      'label', // is string, is label and descriptor of textarea shown in top border
      'label_suffix',
      'is_disabled', // is boolean, controls focus-within behaviour and readonly of textarea
      'is_ready', // is boolean, controls border color transparency when not hovered
      'height', // is number, is static height of container
      'width', // is string, is static width of container
      'dark', // is boolean, makes border and texts black (default is white)
      'background_color', // is string, contains hexcolor of background, needed for label bg
    ],

    components: {
      TText,
    },

    data: () => ({

    }),
  }
</script>

<style>
.label-outlined-component-container {
  display: inline-flex;
  position: relative;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  transition: border-color .1s ease-in-out;
  width: 100%;
  flex-shrink: 0;
}
.label-outlined-component-top-label {
  position: absolute;
  transform: translateY(-7px);
  /* font-size: min(3.5vw, 8pt); */
  line-height: 14px;
  text-align: center;
  padding: 0 3px 0 3px;
  margin: 0 8px;
  height: 14px;
  display: inline-block;
  top: 0;
}
.label-outlined-component-content {
  margin: 8px;
  flex-grow: 1;
  max-width: calc(100%);
  display: inline-block;
  align-self: center;
}
.label-outlined-component-container-light {
  border-color: #FFFFFF40;
}
.label-outlined-component-container-dark {
  border-color: #00000040;
}
.label-outlined-component-container-active.label-outlined-component-container-light:hover {
  border-color: #FFFF;
  transition: border-color .067s ease-in-out;
}
.label-outlined-component-container-active.label-outlined-component-container-dark:hover {
  border-color: #000F;
  transition: border-color .067s ease-in-out;
}
.label-outlined-component-container-light-ready,
.label-outlined-component-container-active.label-outlined-component-container-light:focus-within {
  border-color: #FFF;
}
.label-outlined-component-container-dark-ready,
.label-outlined-component-container-active.label-outlined-component-container-dark:focus-within {
  border-color: #000;
}
.label-outlined-component-container-active:focus-within {
  border-width: 2px;
}
.label-outlined-component-container-active:focus-within
.label-outlined-component-top-label{
  top: -1px;
  margin: 0 7px;
}
.label-outlined-component-container-active:focus-within
.label-outlined-component-content {
  margin: 7px;
}
</style>
